"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _base = _interopRequireDefault(require("./base"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var VertDots = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(VertDots, _Component);

  var _super = _createSuper(VertDots);

  function VertDots() {
    (0, _classCallCheck2["default"])(this, VertDots);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(VertDots, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_base["default"], this.props, /*#__PURE__*/_react["default"].createElement("rect", {
        x: "35.01",
        y: "48.31",
        width: "6.44",
        height: "6.44"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "35.01",
        y: "35.43",
        width: "6.44",
        height: "6.44"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "35.01",
        y: "22.55",
        width: "6.44",
        height: "6.44"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "35.01",
        y: "9.67",
        width: "6.44",
        height: "6.44"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "22.13",
        y: "48.31",
        width: "6.44",
        height: "6.44"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "22.13",
        y: "35.43",
        width: "6.44",
        height: "6.44"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "22.13",
        y: "22.55",
        width: "6.44",
        height: "6.44"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "22.13",
        y: "9.67",
        width: "6.44",
        height: "6.44"
      }));
    }
  }]);
  return VertDots;
}(_react.Component);

exports["default"] = VertDots;
(0, _defineProperty2["default"])(VertDots, "defaultProps", {
  height: '16px',
  predefinedClassName: 'data-ex-icons-vertdot'
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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